import React from "react";
import {
    Navigate,
    Outlet,
    useLocation,
} from "react-router-dom";

export default function ProtectedRoute() {

    const location = useLocation();

    const token = localStorage.getItem("accessToken");

    let userData = null;

    try {
        const storedUser = localStorage.getItem("user");

        userData = storedUser
            ? JSON.parse(storedUser)
            : null;
    } catch (error) {
        console.error(
            "Invalid user data in localStorage:",
            error
        );

        // Clear corrupted data
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken");

        return <Navigate to="/" replace />;
    }

    const role = userData?.role;

    // Not logged in
    if (!token || !userData) {
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken");

        return <Navigate to="/" replace />;
    }

    // Non-admin trying to access admin routes
    if (
        location.pathname.startsWith("/admin") &&
        role !== "admin"
    ) {
        return (
            <Navigate
                to="/user/home"
                replace
            />
        );
    }

    // Non-user trying to access user routes
    if (
        location.pathname.startsWith("/user") &&
        role !== "user"
    ) {
        return (
            <Navigate
                to="/admin/home"
                replace
            />
        );
    }

    return <Outlet />;
}